var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.session || _vm.routeroot)?_c('Navbar'):_vm._e(),_c('div',{staticClass:"J-body-app J-main-app"},[_c('router-view')],1),_c('component-modal-questions')],1)}
var staticRenderFns = []

export { render, staticRenderFns }